import Vue from "vue";
import Router from "vue-router";
import AuthGuard from "./auth-guard";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/login",
      name: "login",
      component: () =>
        import(/* webpackChunkName: "login" */ "../views/Login.vue")
    },
    {
      beforeEnter: AuthGuard,
      path: "/",
      name: "bases",
      component: () =>
        import(/* webpackChunkName: "bases" */ "../views/Bases.vue")
    },
    {
      beforeEnter: AuthGuard,
      path: "/loot",
      name: "loot",
      component: () =>
        import(/* webpackChunkName: "loot" */ "../views/Loot.vue")
    },
    {
      beforeEnter: AuthGuard,
      path: "/config",
      name: "config",
      component: () =>
        import(/* webpackChunkName: "config" */ "../views/Config.vue")
    },
    {
      beforeEnter: AuthGuard,
      path: "/users",
      name: "users",
      component: () =>
        import(/* webpackChunkName: "users" */ "../views/Users.vue")
    }
  ]
});
